// import React, { useState, useEffect } from 'react';
// import { ChevronLeft, Edit2, Tag, ChevronDown, ChevronUp, Plus, Minus, Trash2, X } from 'lucide-react';
// import { useNavigate, useLocation } from "react-router-dom";
// import { fetchUserFromRedis } from "../HomePage/AuthonticationScreens/Register";
// import CustomDialog from "../../CustomDialog";
// import addressConfig from "../../Configurations/addressConfig.json";
// import TIME_SLOTS from "../../Configurations/timeslots.json";

// const COMMUNITY_OPTIONS = addressConfig.communities;
// const BLOCK_OPTIONS = addressConfig.blocks;

// const MedicineDeliveryAddressScreen = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { cart: initialCart, orderType, totalAmount: initialTotal, patientDetails, prescriptionFile } = location.state || {};
  
//   const [dialogOpen, setDialogOpen] = useState(false);
//   const [dialogMessage, setDialogMessage] = useState("");
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);
  
//   // Cart state
//   // const [cart, setCart] = useState(initialCart || []);

//   const [cartTotal, setCartTotal] = useState(initialTotal || 0);

//   // Promo code states
//   const [promoCode, setPromoCode] = useState("");
//   const [appliedPromo, setAppliedPromo] = useState(null);
//   const [promoLoading, setPromoLoading] = useState(false);
//   const [showAvailablePromos, setShowAvailablePromos] = useState(false);
//   const [availablePromos, setAvailablePromos] = useState([]);

//   const [cart, setCart] = useState(() => {
//     // First try to get from sessionStorage
//     const savedCart = sessionStorage.getItem('pharmacyCart');
//     if (savedCart) {
//       try {
//         const parsedCart = JSON.parse(savedCart);
//         if (parsedCart && parsedCart.length > 0) {
//           console.log('✅ Cart restored from sessionStorage:', parsedCart);
//           return parsedCart;
//         }
//       } catch (error) {
//         console.error('Error parsing saved cart:', error);
//       }
//     }
//     // Fall back to initialCart from location.state
//     return initialCart || [];
//   });

//   const [formData, setFormData] = useState({
//     full_name: "",
//     phone: "",
//     community_name: "",
//     address_line1: "",
//     address_line2: "",
//     landmark: "",
//     city: "",
//     state: "",
//     pincode: "",
//     address_type: "home",
//     delivery_time_option: "anytime",
//     delivery_time: "",
//   });

//   // Store original form data for cancel functionality
//   const [originalFormData, setOriginalFormData] = useState(null);

//   const [selectedSlot, setSelectedSlot] = useState(null);
//   const [availableSlots, setAvailableSlots] = useState([]);
//   const [errors, setErrors] = useState({});
//   const [selectedDate, setSelectedDate] = useState("");
//   const [isEditingAddress, setIsEditingAddress] = useState(false);

// // Add these state variables to your component
// const [subscriptionBenefits, setSubscriptionBenefits] = useState(null);
// const [subscriptionDiscount, setSubscriptionDiscount] = useState(0);
// const [loadingSubscription, setLoadingSubscription] = useState(false);

// // Fixed useEffect to fetch subscription benefits with proper error handling
// useEffect(() => {
//   const fetchSubscriptionBenefits = async () => {
//     const userId = sessionStorage.getItem("userId");
//     const token = sessionStorage.getItem("token");
    
//     if (!userId || !token) {
//       console.log("No userId or token found");
//       return;
//     }

//     // Check if the API URL is configured
//     const apiBaseUrl = process.env.REACT_APP_PRICING_API;
//     if (!apiBaseUrl) {
//       console.error("REACT_APP_PRICING_API is not configured in .env file");
//       return;
//     }

//     setLoadingSubscription(true);
//     try {
//       const url = `${apiBaseUrl}/check-benefits/${userId}`;
//       console.log("Fetching subscription benefits from:", url);

//       const response = await fetch(url, {
//         method: "GET",
//         headers: {
//           "Authorization": `Bearer ${token}`,
//           "Content-Type": "application/json"
//         }
//       });

//       // Check if response is actually JSON
//       const contentType = response.headers.get("content-type");
//       if (!contentType || !contentType.includes("application/json")) {
//         console.error("API returned non-JSON response:", contentType);
//         console.error("Response status:", response.status);
//         return;
//       }

//       if (!response.ok) {
//         const errorText = await response.text();
//         console.error(`API error (${response.status}):`, errorText);
//         return;
//       }

//       const data = await response.json();
//       console.log("Subscription benefits response:", data);

//       if (data.success && data.has_subscription) {
//         setSubscriptionBenefits(data);
//         console.log("Active subscription found:", data.subscription.name);
//       } else {
//         console.log("No active subscription found for user");
//         setSubscriptionBenefits(null);
//       }
//     } catch (error) {
//       console.error("Error fetching subscription benefits:", error);
//       // Don't show error to user - just log it
//       // The cart will work normally without subscription discount
//     } finally {
//       setLoadingSubscription(false);
//     }
//   };

//   fetchSubscriptionBenefits();
// }, []);

// // Calculate subscription discount whenever cart changes
// useEffect(() => {
//   if (subscriptionBenefits && subscriptionBenefits.has_subscription) {
//     const medicineDiscountPercent = subscriptionBenefits.benefits.medicine_discount || 0;
//     const discountAmount = (cartTotal * medicineDiscountPercent) / 100;
//     setSubscriptionDiscount(discountAmount);
//     console.log(`Subscription discount calculated: ${medicineDiscountPercent}% = ₹${discountAmount.toFixed(2)}`);
//   } else {
//     setSubscriptionDiscount(0);
//   }
// }, [cartTotal, subscriptionBenefits]);




// // Apply subscription discount to backend - with better error handling
// const applySubscriptionToOrder = async () => {
//   if (!subscriptionBenefits || !subscriptionBenefits.has_subscription) {
//     console.log("No active subscription to apply");
//     return null;
//   }

//   const userId = sessionStorage.getItem("userId");
//   const token = sessionStorage.getItem("token");
  
//   const apiBaseUrl = process.env.REACT_APP_PRICING_API;
//   if (!apiBaseUrl) {
//     console.error("REACT_APP_PRICING_API not configured");
//     return null;
//   }

//   try {
//     const url = `${apiBaseUrl}/apply-subscription`;
//     console.log("Applying subscription discount to order:", url);

//     const response = await fetch(url, {
//       method: "POST",
//       headers: {
//         "Authorization": `Bearer ${token}`,
//         "Content-Type": "application/json"
//       },
//       body: JSON.stringify({
//         user_id: userId,
//         service_type: "medicine",
//         base_price: cartTotal
//       })
//     });

//     // Check content type
//     const contentType = response.headers.get("content-type");
//     if (!contentType || !contentType.includes("application/json")) {
//       console.error("Apply subscription API returned non-JSON response");
//       return null;
//     }

//     if (!response.ok) {
//       const errorText = await response.text();
//       console.error(`Apply subscription error (${response.status}):`, errorText);
//       return null;
//     }

//     const data = await response.json();
//     console.log("Subscription applied successfully:", data);
//     return data;
//   } catch (error) {
//     console.error("Error applying subscription:", error);
//     // Return null but don't block the order
//     return null;
//   }
// };



//   useEffect(() => {
//     setCart(prev =>
//       prev.map((item, index) => ({
//         ...item,
//         id: item.id ? `${item.id}_${index}_${Date.now()}` : `${index}_${Date.now()}`
//       }))
//     );
//   }, []);


  
//   // Calculate cart total whenever cart changes
//   useEffect(() => {
//     const newTotal = cart.reduce((sum, item) => sum + (item.price * item.quantity), 0);
//     setCartTotal(newTotal);
//   }, [cart]);

//   // Fetch available promo codes
//   useEffect(() => {
//     fetchAvailablePromos();
//   }, []);

//   const fetchAvailablePromos = async () => {
//     try {
//       const userId = sessionStorage.getItem("userId");
//       const token = sessionStorage.getItem("token");
      
//           const response = await fetch(
//             `${process.env.REACT_APP_APPLY_PROMOTION_API}/available?service_type=medicine&user_id=${userId}`,
//             {
//           headers: {
//             "Authorization": `Bearer ${token}`,
//             "Content-Type": "application/json"
//           }
//         }
//       );
      
//       if (response.ok) {
//         const data = await response.json();
//         if (data.success) {
//           setAvailablePromos(data.promotions || []);
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching promos:", error);
//     }
//   };

// useEffect(() => {
//   if (appliedPromo) {
//     validateAppliedPromo();
//   }
// }, [cartTotal]);
// const justAppliedPromo = React.useRef(false);

// const applyPromoCode = async (code) => {
//   setPromoLoading(true);
//   try {
//     const userId = sessionStorage.getItem("userId");
//     const token = sessionStorage.getItem("token");
//     const response = await fetch(
//       `${process.env.REACT_APP_APPLY_PROMOTION_API}/apply`,
//       {
//         method: "POST",
//         headers: {
//           "Authorization": `Bearer ${token}`,
//           "Content-Type": "application/json"
//         },
//         body: JSON.stringify({
//           promo_code: code.toUpperCase(),
//           service_type: "medicine",
//           order_price: cartTotal,
//           user_id: userId,
//         }),
//       });

//     const data = await response.json();

//     if (data.success) {
//       justAppliedPromo.current = true;
      
//       setAppliedPromo({
//         code: data.promo_code,
//         discount: data.discount_amount,
//         title: data.title,
//       });
//       setPromoCode("");
//       setShowAvailablePromos(false);
//       setDialogMessage(data.message || "Promo code applied successfully!");
//       setDialogOpen(true);
//     } else {
//       setDialogMessage(data.error || "Invalid promo code");
//       setDialogOpen(true);
//     }
//   } catch (error) {
//     console.error("Error applying promo:", error);
//     setDialogMessage("Failed to apply promo code. Please try again.");
//     setDialogOpen(true);
//   } finally {
//     setPromoLoading(false);
//   }
// };

// const validateAppliedPromo = async () => {
//   if (!appliedPromo) return;
  
//   // ✅ ADD THESE LINES
//   if (justAppliedPromo.current) {
//     justAppliedPromo.current = false;
//     return;
//   }

//   try {
//     const userId = sessionStorage.getItem("userId");
//     const token = sessionStorage.getItem("token");
    
//     const response = await fetch(
//       `${process.env.REACT_APP_APPLY_PROMOTION_API}/apply`,
//       {
//         method: "POST",
//         headers: {
//           "Authorization": `Bearer ${token}`,
//           "Content-Type": "application/json"
//         },
//         body: JSON.stringify({
//           promo_code: appliedPromo.code,
//           service_type: "medicine",
//           order_price: cartTotal,
//           user_id: userId,
//         }),
//       }
//     );

//     const data = await response.json();

//     if (!data.success) {
//       setAppliedPromo(null);
//       setDialogMessage(`Promo code "${appliedPromo.code}" has been removed. ${data.error || "Your cart no longer meets the requirements."}`);
//       setDialogOpen(true);
//     } else if (data.discount_amount !== appliedPromo.discount) {
//       setAppliedPromo({
//         code: data.promo_code,
//         discount: data.discount_amount,
//         title: data.title,
//       });
//     }
//   } catch (error) {
//     console.error("Error validating promo:", error);
//     setAppliedPromo(null);
//   }
// };




//   const removePromoCode = () => {
//     setAppliedPromo(null);
//     setDialogMessage("Promo code removed");
//     setDialogOpen(true);
//   };
//   const updateQuantity = (itemId, change) => {
//     setCart(prevCart => {
//       const updatedCart = prevCart
//         .map(item => {
//           if (item.id === itemId) {
//             const newQuantity = item.quantity + change;
//             return { ...item, quantity: newQuantity };
//           }
//           return item;
//         })
//         .filter(item => item.quantity > 0); // removes item when qty becomes 0
  
//       // Save updated cart (can be empty [])
//       sessionStorage.setItem("pharmacyCart", JSON.stringify(updatedCart));
  
//       return updatedCart;
//     });
//       // Remove applied promo when cart is updated
//   if (appliedPromo) {
//     setAppliedPromo(null);
//     // setDialogMessage("Cart updated. Promo code removed. Please reapply if eligible.");
//     // setDialogOpen(true);
//   }
//   };
  
//   const removeItem = (itemId) => {
//     setCart(prevCart => {
//       const updatedCart = prevCart.filter(item => item.id !== itemId);
  
//       // Save updated cart (can be empty [])
//       sessionStorage.setItem("pharmacyCart", JSON.stringify(updatedCart));
//       return updatedCart;
//     });
//       // Remove applied promo when item is removed
//   if (appliedPromo) {
//     setAppliedPromo(null);
//     // setDialogMessage("Item removed from cart. Promo code removed. Please reapply if eligible.");
//     // setDialogOpen(true);
//   }
//   };
  
  
//   const handleDateChange = (dateString) => {
//     setSelectedDate(dateString);
//     setSelectedSlot("");
//     handleInputChange("delivery_time", "");

//     const selected = new Date(dateString);
//     const now = new Date();

//     const isToday =
//       selected.getDate() === now.getDate() &&
//       selected.getMonth() === now.getMonth() &&
//       selected.getFullYear() === now.getFullYear();

//     let slots;
//     if (isToday) {
//       const currentHour = now.getHours();
//       slots = TIME_SLOTS.map((slot) => ({
//         ...slot,
//         disabled: currentHour >= slot.end
//       }));
//     } else {
//       slots = TIME_SLOTS.map((slot) => ({ ...slot, disabled: false }));
//     }

//     setAvailableSlots(slots);
//   };

//   useEffect(() => {
//     const loadUserData = async () => {
//       const userId = sessionStorage.getItem("userId");
//       const token = sessionStorage.getItem("token");
    
      
//       if (!userId || !token) {
//         setUser(null);
//         setLoading(false);
//         return;
//       }
  
//       try {
//         const userData = await fetchUserFromRedis(userId, token);
        
//         console.log("📦 Received userData:", userData);
        
//         if (userData) {
//           setUser(userData);
          
//           if (userData.address && userData.address.full_name) {
//             console.log("✅ Loading updated address from profile:", userData.address);
//             setFormData({
//               full_name: userData.address.full_name || userData.name || "",
//               phone: userData.address.phone || userData.phone || "",
//               community_name: userData.address.community_name || "",
//               address_line1: userData.address.address_line1 || "",
//               address_line2: userData.address.address_line2 || "",
//               landmark: userData.address.landmark || "",
//               city: userData.address.city || "",
//               state: userData.address.state || "",
//               pincode: userData.address.pincode || "",
//               address_type: userData.address.address_type || "home",
//               delivery_time_option: "anytime",
//               delivery_time: "",
//             });
//             console.log(" Address populated in formData");
//           } else {
//             console.log(" No address found in userData");
//             setFormData(prev => ({
//               ...prev,
//               full_name: userData.name || "",
//               phone: userData.phone || "",
//             }));
//           }
//         } else {
//           console.log(" No userData returned");
//         }
//       } catch (err) {
//         console.error(" Error fetching user from Redis:", err);
//         setUser(null);
//       } finally {
//         setLoading(false);
//         console.log(" Loading complete");
//       }
//     };
  
//     loadUserData();
//   }, []);

//   const handleInputChange = (field, value) => {
//     setFormData({ ...formData, [field]: value });
//     if (errors[field]) {
//       setErrors({ ...errors, [field]: "" });
//     }
//   };

//   const handleEditAddress = () => {
//     // Save current state before editing
//     setOriginalFormData({ ...formData });
//     setIsEditingAddress(true);
//   };

//   const handleCancelEdit = () => {
//     // Restore original data
//     if (originalFormData) {
//       setFormData(originalFormData);
//     }
//     setErrors({});
//     setSelectedDate("");
//     setSelectedSlot("");
//     setIsEditingAddress(false);
//   };

//   const handleSaveAddress = () => {
//     setIsEditingAddress(false);
//     setOriginalFormData(null);
//   };

//   const validateForm = () => {
//     const newErrors = {};

//     if (!formData.full_name.trim()) newErrors.full_name = "Full name is required";
//     if (!formData.phone.trim()) {
//       newErrors.phone = "Phone number is required";
//   } else if (!/^(\+91)?\d{10}$/.test(formData.phone)) {
//     newErrors.phone = 'Please enter a valid 10-digit phone number';
//   }
  
//     if (!formData.community_name.trim()) newErrors.community_name = "Community/Society name is required";
//     if (!formData.address_line1.trim()) newErrors.address_line1 = "Block/Building is required";
//     // if (!formData.city.trim()) newErrors.city = "City is required";
//     // if (!formData.state.trim()) newErrors.state = "State is required";
//     // if (!formData.pincode.trim()) {
//     //   newErrors.pincode = "Pincode is required";
//     // } else if (!/^\d{6}$/.test(formData.pincode)) {
//     //   newErrors.pincode = "Please enter a valid 6-digit pincode";
//     // }

//     if (formData.delivery_time_option === "specific") {
//       if (!selectedDate) newErrors.selectedDate = "Please select a delivery date";
//       if (!formData.delivery_time) newErrors.delivery_time = "Please select a delivery time slot";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };


// // Updated handleProceed with better error handling
// const handleProceed = async () => {
//   if (cart.length === 0) {
//     setDialogMessage("Your cart is empty. Please add items to proceed.");
//     setDialogOpen(true);
//     return;
//   }

//   if (!validateForm()) {
//     setDialogMessage("Please fill all required fields correctly");
//     setDialogOpen(true);
//     return;
//   }

//   try {
//     sessionStorage.setItem('pharmacyCart', JSON.stringify(cart));
//     sessionStorage.setItem('pharmacyPatientDetails', JSON.stringify(patientDetails));
//     sessionStorage.setItem('pharmacyDeliveryAddress', JSON.stringify(formData));
//     if (prescriptionFile) {
//       sessionStorage.setItem('pharmacyPrescription', prescriptionFile);
//     }
//     console.log('✅ Cart and details saved to sessionStorage before navigation');

//     // Try to apply subscription (won't block order if it fails)
//     const subscriptionResponse = await applySubscriptionToOrder();

//     const deliveryAddress = {
//       ...formData,
//       delivery_time_option: formData.delivery_time_option,
//       delivery_time: formData.delivery_time_option === "anytime" ? "Anytime" : formData.delivery_time,
//       delivery_date: selectedDate
//     };

//     // Prepare subscription discount data
//     const subscriptionData = subscriptionResponse || {
//       applied: subscriptionBenefits?.has_subscription || false,
//       discount_amount: subscriptionDiscount,
//       subscription_name: subscriptionBenefits?.subscription?.name || null,
//       subscription_id: subscriptionBenefits?.subscription?.subscription_id || null,
//       discount_percent: subscriptionBenefits?.benefits?.medicine_discount || 0
//     };

//     console.log("Proceeding to payment with subscription data:", subscriptionData);

//     navigate("/MedicinePayment", {
//       state: {
//         cart,
//         orderType,
//         patientDetails,
//         totalAmount: finalAmount,
//         prescriptionFile,
//         deliveryAddress,
//         userEmail: user?.email,
//         userPhone: formData.phone,
//         appliedPromo,
//         subscriptionDiscount: subscriptionData.discount_amount,
//         promoDiscount: appliedPromo ? appliedPromo.discount : 0, 
//         promoCode: appliedPromo ? appliedPromo.code : "",
//         subscriptionBenefits: subscriptionBenefits,
//       }
//     });
//   } catch (error) {
//     console.error("Error in handleProceed:", error);
//     setDialogMessage("An error occurred. Please try again.");
//     setDialogOpen(true);
//   }
// };
//   const deliveryCharge = Number(process.env.REACT_APP_DELIVERY_CHARGE) || 0;
//   const discountAmount = appliedPromo ? appliedPromo.discount : 0;
//   // const finalAmount = cartTotal + deliveryCharge - discountAmount;
//   const finalAmount = cartTotal + deliveryCharge - subscriptionDiscount - discountAmount;



//   const styles = {
//     container: { flex: 1, backgroundColor: "#F9FAFB", minHeight: "100vh", paddingBottom: "100px" },
//     header: {
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "center",
//       padding: "16px",
//       backgroundColor: "#fff",
//       boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
//       position: "sticky",
//       top: 0,
//       zIndex: 1000,
//     },
//     backButton: { padding: "8px", border: "none", background: "none", cursor: "pointer" },
//     headerTitle: { fontSize: "20px", fontWeight: "700", color: "#111827", margin: 0 },
//     scrollContent: { padding: "16px", maxWidth: "900px", margin: "0 auto", width: "90%" },
//     card: {
//       backgroundColor: "#fff",
//       borderRadius: "16px",
//       padding: "20px",
//       marginBottom: "16px",
//       boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
//     },
//     cardTitle: { fontSize: "18px", fontWeight: "700", color: "#111827", marginBottom: "16px", marginTop: 0 },
//     cartItem: {
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "center",
//       padding: "12px",
//       backgroundColor: "#F9FAFB",
//       borderRadius: "12px",
//       marginBottom: "12px",
//     },
//     itemDetails: { flex: 1 },
//     itemName: { fontSize: "15px", fontWeight: "600", color: "#111827", marginBottom: "4px" },
//     itemPrice: { fontSize: "14px", color: "#6B7280" },
//     quantityControl: {
//       display: "flex",
//       alignItems: "center",
//       gap: "12px",
//     },
//     qtyButton: {
//       width: "32px",
//       height: "32px",
//       borderRadius: "8px",
//       border: "1px solid #D1D5DB",
//       backgroundColor: "#fff",
//       cursor: "pointer",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       transition: "all 0.2s",
//     },
//     qtyText: { fontSize: "16px", fontWeight: "600", minWidth: "24px", textAlign: "center" },
//     deleteButton: {
//       padding: "8px",
//       border: "none",
//       background: "none",
//       cursor: "pointer",
//       color: "#EF4444",
//     },
//     addressSummary: {
//       padding: "16px",
//       backgroundColor: "#F9FAFB",
//       borderRadius: "12px",
//       marginBottom: "12px",
//     },
//     editButton: {
//       display: "flex",
//       alignItems: "center",
//       gap: "8px",
//       padding: "10px 16px",
//       backgroundColor: "#006D77",
//       color: "#fff",
//       border: "none",
//       borderRadius: "8px",
//       cursor: "pointer",
//       fontSize: "14px",
//       fontWeight: "600",
//       marginTop: "12px",
//     },
//     closeButton: {
//       padding: "8px",
//       border: "none",
//       background: "none",
//       cursor: "pointer",
//       color: "#6B7280",
//       display: "flex",
//       alignItems: "center",
//       gap: "4px",
//       fontSize: "14px",
//       fontWeight: "600",
//     },
//     summaryRow: { display: "flex", justifyContent: "space-between", marginBottom: "12px" },
//     summaryLabel: { fontSize: "14px", color: "#6B7280" },
//     summaryValue: { fontSize: "14px", fontWeight: "600", color: "#111827" },
//     divider: { height: "1px", backgroundColor: "#E5E7EB", margin: "12px 0" },
//     promoInput: { display: "flex", gap: "8px", marginTop: "12px" },
//     input: {
//       flex: 1,
//       border: "1px solid #D1D5DB",
//       borderRadius: "8px",
//       padding: "10px 12px",
//       fontSize: "14px",
//       fontFamily: "inherit",
//     },
//     button: {
//       padding: "10px 20px",
//       borderRadius: "8px",
//       border: "none",
//       cursor: "pointer",
//       fontSize: "14px",
//       fontWeight: "600",
//       transition: "all 0.2s",
//     },
//     primaryButton: { backgroundColor: "#006D77", color: "#fff" },
//     secondaryButton: { backgroundColor: "#fff", color: "#006D77", border: "1px solid #006D77" },
//     dangerButton: { backgroundColor: "#EF4444", color: "#fff" },
//     promoTag: {
//       display: "inline-flex",
//       alignItems: "center",
//       gap: "8px",
//       backgroundColor: "#D1FAE5",
//       color: "#065F46",
//       padding: "8px 12px",
//       borderRadius: "8px",
//       fontSize: "14px",
//       fontWeight: "600",
//       marginTop: "8px",
//     },
//     promoCard: {
//       border: "1px solid #E5E7EB",
//       borderRadius: "12px",
//       padding: "16px",
//       marginBottom: "12px",
//       cursor: "pointer",
//       transition: "all 0.2s",
//     },
//     inputGroup: { marginBottom: "20px" },
//     label: { fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "8px", display: "block" },
//     required: { color: "#EF4444" },
//     formInput: {
//       width: "100%",
//       border: "1px solid #D1D5DB",
//       borderRadius: "8px",
//       padding: "12px 16px",
//       fontSize: "16px",
//       color: "#111827",
//       backgroundColor: "#fff",
//       boxSizing: "border-box",
//       fontFamily: "inherit",
//     },
//     inputError: { borderColor: "#EF4444" },
//     errorText: { fontSize: "12px", color: "#EF4444", marginTop: "4px" },
//     row: { display: "flex", gap: "16px" },
//     addressTypeButton: {
//       flex: 1,
//       padding: "12px",
//       borderRadius: "8px",
//       border: "1px solid #D1D5DB",
//       textAlign: "center",
//       cursor: "pointer",
//       backgroundColor: "#fff",
//       transition: "all 0.2s",
//     },
//     addressTypeButtonActive: { backgroundColor: "#006D77", borderColor: "#006D77" },
//     addressTypeText: { fontSize: "14px", fontWeight: "600", color: "#6B7280" },
//     addressTypeTextActive: { color: "#fff" },
//     buttonContainer: {
//       position: "fixed",
//       bottom: 0,
//       left: 0,
//       right: 0,
//       backgroundColor: "#fff",
//       padding: "16px",
//       boxShadow: "0 -2px 8px rgba(0,0,0,0.1)",
//       zIndex: 1000,
//     },
//     proceedButton: {
//       backgroundColor: "#006D77",
//       padding: "16px",
//       borderRadius: "12px",
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",
//       border: "none",
//       cursor: "pointer",
//       maxWidth: "900px",
//       margin: "0 auto",
//       width: "100%",
//     },
//     proceedButtonText: { color: "#fff", fontSize: "16px", fontWeight: "700", marginRight: "8px" },
//     proceedButtonAmount: { color: "#fff", fontSize: "18px", fontWeight: "700" },
//   };

//   if (loading) {
//     return (
//       <div style={styles.container}>
//         <div style={styles.header}>
//           <button onClick={() => navigate(-1)} style={styles.backButton}>
//             <ChevronLeft size={24} />
//           </button>
//           <h1 style={styles.headerTitle}>Delivery Address</h1>
//           <div style={{ width: "40px" }} />
//         </div>
//         <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "200px" }}>
//           <p>Loading...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div style={styles.container}>
//       <div style={styles.header}>
//         <button onClick={() => navigate(-1)} style={styles.backButton}>
//           <ChevronLeft size={24} />
//         </button>
//         <h1 style={styles.headerTitle}>Delivery Address</h1>
//         <div style={{ width: "40px" }} />
//       </div>

//       <div style={styles.scrollContent}>
//         {/* Cart Items */}
//         <div style={styles.card}>
//           <h2 style={styles.cardTitle}>Cart Items ({cart.length})</h2>
//           {cart.map((item) => (
//             <div key={item.id} style={styles.cartItem}>
//               <div style={styles.itemDetails}>
//                 <div style={styles.itemName}>{item.name}</div>
//                 <div style={styles.itemPrice}>₹{item.price.toFixed(2)} each</div>
//               </div>
//               <div style={styles.quantityControl}>
//                 <button
//                   onClick={() => updateQuantity(item.id, -1)}
//                   style={styles.qtyButton}
//                   onMouseEnter={(e) => e.target.style.backgroundColor = "#F3F4F6"}
//                   onMouseLeave={(e) => e.target.style.backgroundColor = "#fff"}
//                 >
//                   <Minus size={16} />
//                 </button>
//                 <span style={styles.qtyText}>{item.quantity}</span>
//                 <button
//                   onClick={() => updateQuantity(item.id, 1)}
//                   style={styles.qtyButton}
//                   onMouseEnter={(e) => e.target.style.backgroundColor = "#F3F4F6"}
//                   onMouseLeave={(e) => e.target.style.backgroundColor = "#fff"}
//                 >
//                   <Plus size={16} />
//                 </button>
//                 {cart.length > 1 && (
//                   <button onClick={() => removeItem(item.id)} style={styles.deleteButton}>
//                     <Trash2 size={18} />
//                   </button>
//                 )}
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Order Summary with Promo */}
//         <div style={styles.card}>
//           <h2 style={styles.cardTitle}>Order Summary</h2>
          
//           <div style={styles.summaryRow}>
//             <span style={styles.summaryLabel}>Subtotal ({cart.length} items)</span>
//             <span style={styles.summaryValue}>₹{cartTotal.toFixed(2)}</span>
//           </div>
          
//           <div style={styles.summaryRow}>
//             <span style={styles.summaryLabel}>Delivery Charge</span>
//             <span style={styles.summaryValue}>
//               {deliveryCharge === 0 ? (
//                 <>
//                   <span style={{ textDecoration: "line-through", color: "gray" }}>₹50</span> ₹0
//                 </>
//               ) : (
//                 `₹${deliveryCharge}`
//               )}
//             </span>
//           </div>
//           {/* Subscription Discount Display */}
//           {subscriptionBenefits && subscriptionBenefits.has_subscription && subscriptionDiscount > 0 && (
//             <div style={styles.summaryRow}>
//               <span style={{ ...styles.summaryLabel, color: "#8B5CF6" }}>
//                 Subscription Discount ({subscriptionBenefits.benefits.medicine_discount}%)
//                 <div style={{ fontSize: "11px", color: "#9CA3AF", marginTop: "2px" }}>
//                   {subscriptionBenefits.subscription.name}
//                 </div>
//               </span>
//               <span style={{ ...styles.summaryValue, color: "#8B5CF6" }}>
//                 -₹{subscriptionDiscount.toFixed(2)}
//               </span>
//             </div>
//           )}
//         {/* Promo Code Discount */}
//           {appliedPromo && (
//             <div style={styles.summaryRow}>
//               <span style={{ ...styles.summaryLabel, color: "#10B981" }}>
//                 Discount ({appliedPromo.code})
//               </span>
//               <span style={{ ...styles.summaryValue, color: "#10B981" }}>
//                 -₹{appliedPromo.discount.toFixed(2)}
//               </span>
//             </div>
//           )}

//           <div style={styles.divider} />

//           <div style={styles.summaryRow}>
//             <span style={{ fontSize: "16px", fontWeight: "700", color: "#111827" }}>Total Amount</span>
//             <span style={{ fontSize: "20px", fontWeight: "700", color: "#006D77" }}>
//               ₹{finalAmount.toFixed(2)}
//             </span>
//           </div>

//           {/* Promo Code Section */}
//           {!appliedPromo ? (
//             <>
//               <div style={styles.promoInput}>
//                 <input
//                   type="text"
//                   placeholder="Enter promo code"
//                   value={promoCode}
//                   onChange={(e) => setPromoCode(e.target.value.toUpperCase())}
//                   style={styles.input}
//                 />
//                 <button
//                   onClick={() => applyPromoCode(promoCode)}
//                   disabled={!promoCode || promoLoading}
//                   style={{
//                     ...styles.button,
//                     ...styles.primaryButton,
//                     opacity: !promoCode ? 0.5 : 1
//                   }}
//                 >
//                   {promoLoading ? "Applying..." : "Apply"}
//                 </button>
//               </div>

//               <button
//                 onClick={() => setShowAvailablePromos(!showAvailablePromos)}
//                 style={{
//                   ...styles.button,
//                   ...styles.secondaryButton,
//                   width: "100%",
//                   marginTop: "8px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   gap: "8px",
//                 }}
//               >
//                 <Tag size={16} />
//                 View Available Offers
//                 {showAvailablePromos ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
//               </button>



//     {/* Show subscription badge if active */}
//     {subscriptionBenefits && subscriptionBenefits.has_subscription && (
//       <div style={{
//         backgroundColor: "#F3E8FF",
//         padding: "12px",
//         borderRadius: "8px",
//         marginTop: "12px",
//         border: "1px solid #DDD6FE"
//       }}>
//         <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px" }}>
//           <span style={{ fontSize: "14px", fontWeight: "600", color: "#7C3AED" }}>
//             🎉 Active Subscription
//           </span>
//         </div>
//         <div style={{ fontSize: "12px", color: "#6B7280" }}>
//           Saving {subscriptionBenefits.benefits.medicine_discount}% on medicine orders
//         </div>
//         <div style={{ fontSize: "11px", color: "#9CA3AF", marginTop: "4px" }}>
//           {subscriptionBenefits.subscription.days_remaining} days remaining
//         </div>
//       </div>
//     )}







//               {showAvailablePromos && availablePromos.length > 0 && (
//                 <div style={{ marginTop: "12px" }}>
//                   {availablePromos.map((promo, index) => (
//                     <div
//                       key={index}
//                       style={styles.promoCard}
//                       onMouseEnter={(e) => {
//                         e.currentTarget.style.borderColor = "#006D77";
//                         e.currentTarget.style.backgroundColor = "#F0FDFA";
//                       }}
//                       onMouseLeave={(e) => {
//                         e.currentTarget.style.borderColor = "#E5E7EB";
//                         e.currentTarget.style.backgroundColor = "#fff";
//                       }}
//                       onClick={() => applyPromoCode(promo.promo_code)}
//                     >
//                       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start" }}>
//                         <div>
//                           <div style={{ fontSize: "16px", fontWeight: "700", color: "#111827", marginBottom: "4px" }}>
//                             {promo.promo_code}
//                           </div>
//                           <div style={{ fontSize: "14px", color: "#6B7280", marginBottom: "8px" }}>
//                             {promo.description}
//                           </div>
//                           <div style={{ fontSize: "12px", color: "#9CA3AF" }}>
//                             Min order: ₹{promo.min_order_value}
//                             {promo.max_discount > 0 && ` • Max discount: ₹${promo.max_discount}`}
//                           </div>
//                         </div>
//                         <button
//                           style={{
//                             ...styles.button,
//                             ...styles.primaryButton,
//                             fontSize: "12px",
//                             padding: "6px 12px"
//                           }}
//                         >
//                           Apply
//                         </button>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </>
//           ) : (
//             <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//               <div style={styles.promoTag}>
//                 <Tag size={16} />
//                 {appliedPromo.code} Applied
//               </div>
//               <button
//                 onClick={removePromoCode}
//                 style={{ ...styles.button, ...styles.dangerButton, fontSize: "12px", padding: "6px 12px" }}
//               >
//                 Remove
//               </button>
//             </div>
//           )}
//         </div>


        


//         {/* Address Form */}
//         <div style={styles.card}>
//           <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
//             <h2 style={{ ...styles.cardTitle, marginBottom: 0 }}>Delivery Details</h2>
//             {isEditingAddress && (
//               <button onClick={handleCancelEdit} style={styles.closeButton}>
//                 <X size={20} />
//                 <span>Close</span>
//               </button>
//             )}
//           </div>

//           {!isEditingAddress ? (
//             <>
//               <div style={styles.addressSummary}>
//                 <div style={{ fontSize: "16px", fontWeight: "600", color: "#111827", marginBottom: "8px" }}>
//                 <strong> Name:</strong> {formData.full_name}
//                 </div>
//                 <div style={{ fontSize: "14px", color: "#6B7280", marginBottom: "4px" }}>
//                 <strong> Mobile:</strong>  {formData.phone}
//                 </div>
//                 <div style={{ fontSize: "14px", color: "#6B7280", lineHeight: "1.6" }}>
//                 <strong>Community Name:</strong>{formData.community_name} <br />
//                 <strong>Block:</strong> {formData.address_line1},   <br />
//                 <strong>Flat No:</strong> {formData.address_line2 && `${formData.address_line2}, `}   <br />


//                   {/* {formData.landmark && `, ${formData.landmark}`}
//                   <br />
//                   {formData.city}, {formData.state} - {formData.pincode} */}
//                 </div>
      
//               </div>
              
//               <button onClick={handleEditAddress} style={styles.editButton}>
//                 <Edit2 size={16} />
//                 Edit Address
//               </button>
//             </>
//           ) : (

// <>
// <div style={styles.inputGroup}>
//   <label style={styles.label}>
//     Full Name <span style={styles.required}>*</span>
//   </label>
//   <input
//     type="text"
//     readOnly
//     style={{ ...styles.formInput, ...(errors.full_name ? styles.inputError : {}) }}
//     placeholder="Enter your full name"
//     value={formData.full_name}
//     onChange={(e) => handleInputChange("full_name", e.target.value)}
//   />
//   {errors.full_name && <p style={styles.errorText}>{errors.full_name}</p>}
// </div>

// <div style={styles.inputGroup}>
//   <label style={styles.label}>
//     Phone Number <span style={styles.required}>*</span>
//   </label>
//   <input
//     type="tel"
//     readOnly
//     style={{ ...styles.formInput, ...(errors.phone ? styles.inputError : {}) }}
//     placeholder="Enter 10-digit phone number"
//     value={formData.phone}
//     onChange={(e) => {
//       const value = e.target.value.replace(/\D/g, "").slice(0, 10);
//       handleInputChange("phone", value);
//     }}
//     maxLength={10}
//   />
//   {errors.phone && <p style={styles.errorText}>{errors.phone}</p>}
// </div>

// <div style={styles.inputGroup}>
//   <label style={styles.label}>
//     Community/Society Name <span style={styles.required}>*</span>
//   </label>

//   <select
//     value={formData.community_name}
//     onChange={(e) =>
//       setFormData(prev => ({
//         ...prev,
//         community_name: e.target.value,
//       }))
//     }
//     style={styles.formInput}
//   >
//     <option value="">Select Community</option>
//     {COMMUNITY_OPTIONS.map((community) => (
//       <option key={community} value={community}>
//         {community}
//       </option>
//     ))}
//   </select>
// </div>


// <div style={styles.inputGroup}>
//   <label style={styles.label}>
//     Block/Building <span style={styles.required}>*</span>
//   </label>
//   <select
//     style={{ ...styles.formInput, ...(errors.address_line1 ? styles.inputError : {}) }}
//     value={formData.address_line1}
//     onChange={(e) => handleInputChange("address_line1", e.target.value)}
//   >
//     <option value="">Select Block</option>
//     {BLOCK_OPTIONS.map((block) => (
//       <option key={block} value={block}>
//         {block}
//       </option>
//     ))}
//   </select>
//   {errors.address_line1 && <p style={styles.errorText}>{errors.address_line1}</p>}
// </div>

// <div style={styles.inputGroup}>
//   <label style={styles.label}>Flat/House Number</label>
//   <input
//     type="text"
//     style={styles.formInput}
//     placeholder="Flat or House Number (Optional)"
//     value={formData.address_line2}
//     onChange={(e) => handleInputChange("address_line2", e.target.value)}
//   />
// </div>

// <div style={{...styles.inputGroup , display: "none"}}>
//   <label style={styles.label}>Landmark</label>
//   <input
//     type="text"
//     style={styles.formInput}
//     placeholder="Near... (Optional)"
//     value={formData.landmark}
//     onChange={(e) => handleInputChange("landmark", e.target.value)}
//   />
// </div>

// <div style={{...styles.inputGroup , display: "none"}}>
//   <div style={{ ...styles.inputGroup, flex: 1 }}>
//     <label style={styles.label}>
//       City <span style={styles.required}>*</span>
//     </label>
//     <input
//       type="text"
//       readOnly
//       style={{ ...styles.formInput, ...(errors.city ? styles.inputError : {}) }}
//       value={formData.city}
//     />
//     {errors.city && <p style={styles.errorText}>{errors.city}</p>}
//   </div>

//   <div style={{ ...styles.inputGroup, flex: 1 , display: "none"}}>
//     <label style={styles.label}>
//       State <span style={styles.required}>*</span>
//     </label>
//     <input
//       type="text"
//       readOnly
//       style={{ ...styles.formInput, ...(errors.state ? styles.inputError : {}) }}
//       value={formData.state}
//     />
//     {errors.state && <p style={styles.errorText}>{errors.state}</p>}
//   </div>
// </div>

// <div style={{...styles.inputGroup , display: "none"}}>
//   <label style={styles.label}>
//     Pincode <span style={styles.required}>*</span>
//   </label>
//   <input
//     type="text"
//     readOnly
//     style={{ ...styles.formInput, ...(errors.pincode ? styles.inputError : {}) }}
//     value={formData.pincode}
//   />
//   {errors.pincode && <p style={styles.errorText}>{errors.pincode}</p>}
// </div>


// <button
//   onClick={() => setIsEditingAddress(false)}
//   style={{ ...styles.button, ...styles.secondaryButton, width: "100%", marginTop: "12px" }}
// >
//   Save Address
// </button>
// </>
// )}
// </div>


// {/* Delivery Time Selection - Fully Switchable */}
// <div style={styles.inputGroup}>
//   <label style={styles.label}>
//     Preferred Delivery Time <span style={styles.required}>*</span>
//   </label>
//   <div style={{ display: "flex", gap: "12px" }}>
//     {/* ANYTIME BUTTON */}
//     <button
//       type="button"
//       style={{
//         ...styles.addressTypeButton,
//         ...(formData.delivery_time_option === "anytime" ? styles.addressTypeButtonActive : {}),
//       }}
//       onClick={() => {
//         handleInputChange("delivery_time_option", "anytime");
//         setSelectedDate("");
//         setSelectedSlot("");
//         setAvailableSlots([]);
//         setErrors((prev) => ({ ...prev, selectedDate: "", delivery_time: "" }));
//       }}
//     >
//       <span
//         style={{
//           ...styles.addressTypeText,
//           ...(formData.delivery_time_option === "anytime" ? styles.addressTypeTextActive : {}),
//         }}
//       >
//         Anytime
//       </span>
//     </button>
    
//     {/* SPECIFIC TIME BUTTON */}
//     <button
//       type="button"
//       style={{
//         ...styles.addressTypeButton,
//         ...(formData.delivery_time_option === "specific" ? styles.addressTypeButtonActive : {}),
//       }}
//       onClick={() => {
//         handleInputChange("delivery_time_option", "specific");
//         setSelectedDate("");
//         setSelectedSlot("");
//         setAvailableSlots([]);
//         setErrors((prev) => ({ ...prev, selectedDate: "", delivery_time: "" }));
//       }}
//     >
//       <span
//         style={{
//           ...styles.addressTypeText,
//           ...(formData.delivery_time_option === "specific" ? styles.addressTypeTextActive : {}),
//         }}
//       >
//         Specific Time
//       </span>
//     </button>
//   </div>
// </div>

// {/* SHOW DATE AND TIME SLOTS WHEN SPECIFIC TIME IS SELECTED */}
// {formData.delivery_time_option === "specific" && (
//   <>
//     {/* DATE SELECTION - EDITABLE */}
//     <div style={styles.inputGroup}>
//       <label style={styles.label}>
//         Select Date <span style={styles.required}>*</span>
//       </label>
//       {/* <input
//         type="date"
//         value={selectedDate}
//         min={new Date().toISOString().split("T")[0]}
//         max={(() => {
//           const maxDate = new Date();
//           maxDate.setDate(maxDate.getDate() + 10);
//           return maxDate.toISOString().split("T")[0];
//         })()}
//         onChange={(e) => handleDateChange(e.target.value)}
//         onKeyDown={(e) => e.preventDefault()}
//         onClick={(e) => e.target.showPicker()}
//         style={{
//           ...styles.formInput,
//           ...(errors.selectedDate ? styles.inputError : {})
//         }}
//       /> */}
//       <input
//         type="date"
//         value={selectedDate}
//         min={new Date().toISOString().split("T")[0]}
//         max={(() => {
//           const maxDate = new Date();
//           maxDate.setDate(maxDate.getDate() + 10);
//           return maxDate.toISOString().split("T")[0];
//         })()}
//         onChange={(e) => handleDateChange(e.target.value)}
//         onKeyDown={(e) => e.preventDefault()}   
//         onClick={(e) => e.currentTarget.showPicker()} 
//         style={{
//           ...styles.formInput,
//           cursor: "pointer",
//           ...(errors.selectedDate ? styles.inputError : {})
//         }}
//       />

//       {errors.selectedDate && <p style={styles.errorText}>{errors.selectedDate}</p>}
//     </div>

//     {/* TIME SLOTS - SHOW AFTER DATE IS SELECTED, EDITABLE */}
//     {selectedDate && availableSlots.length > 0 && (
//       <div style={styles.inputGroup}>
//         <label style={styles.label}>
//           Available Time Slots <span style={styles.required}>*</span>
//         </label>
//         <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
//           {availableSlots.map((slot, index) => (
//             <button
//               key={index}
//               type="button"
//               disabled={slot.disabled}
//               onClick={() => {
//                 const combined = `${selectedDate} | ${slot.label}`;
//                 setSelectedSlot(slot.label);
//                 handleInputChange("delivery_time", combined);
//                 setErrors((prev) => ({ ...prev, delivery_time: "" }));
//               }}
//               style={{
//                 padding: "12px",
//                 borderRadius: "12px",
//                 border: selectedSlot === slot.label ? "2px solid #006D77" : "1px solid #ccc",
//                 background: selectedSlot === slot.label ? "#006D77" : slot.disabled ? "#eee" : "#fff",
//                 color: selectedSlot === slot.label ? "#fff" : slot.disabled ? "#999" : "#333",
//                 cursor: slot.disabled ? "not-allowed" : "pointer",
//                 fontWeight: 600,
//                 transition: "all 0.2s",
//               }}
//               onMouseEnter={(e) => {
//                 if (!slot.disabled && selectedSlot !== slot.label) {
//                   e.target.style.backgroundColor = "#f0f9ff";
//                   e.target.style.borderColor = "#006D77";
//                 }
//               }}
//               onMouseLeave={(e) => {
//                 if (!slot.disabled && selectedSlot !== slot.label) {
//                   e.target.style.backgroundColor = "#fff";
//                   e.target.style.borderColor = "#ccc";
//                 }
//               }}
//             >
//               ⏱ {slot.label} {slot.disabled ? "(Unavailable)" : ""}
//             </button>
//           ))}
//         </div>
//         {errors.delivery_time && <p style={styles.errorText}>{errors.delivery_time}</p>}
//       </div>
//     )}
//   </>
// )}

// {/* Summary display */}
// <div style={{ fontSize: "14px", color: "#6B7280", marginTop: "8px" }}>
//   <strong>Delivery Time:</strong>{" "}
//   {formData.delivery_time_option === "anytime" 
//     ? "Anytime" 
//     : formData.delivery_time || "Not selected"}
// </div>



// </div>
















// <div style={styles.buttonContainer}>
// <button
// style={styles.proceedButton}
// onClick={handleProceed}
// onMouseEnter={(e) => (e.target.style.backgroundColor = "#005761")}
// onMouseLeave={(e) => (e.target.style.backgroundColor = "#006D77")}
// >
// <span style={styles.proceedButtonText}>Proceed to Payment</span>
// <span style={styles.proceedButtonAmount}>₹{finalAmount.toFixed(2)}</span>
// </button>
// </div>

// <CustomDialog
// open={dialogOpen}
// message={dialogMessage}
// onClose={() => setDialogOpen(false)}
// />
// </div>
// );
// };

// export default MedicineDeliveryAddressScreen;

import React, { useState, useEffect } from 'react';
import { ChevronLeft, Edit2, Tag, ChevronDown, ChevronUp, Plus, Minus, Trash2, X, Clock } from 'lucide-react';
import { useNavigate, useLocation } from "react-router-dom";
import { fetchUserFromRedis } from "../HomePage/AuthonticationScreens/Register";
import CustomDialog from "../../CustomDialog";
import addressConfig from "../../Configurations/addressConfig.json";
import TIME_SLOTS from "../../Configurations/timeslots.json";

const COMMUNITY_OPTIONS = addressConfig.communities;
const BLOCK_OPTIONS = addressConfig.blocks;

const MedicineDeliveryAddressScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { cart: initialCart, orderType, totalAmount: initialTotal, patientDetails, prescriptionFile } = location.state || {};
  
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  
  const [cartTotal, setCartTotal] = useState(initialTotal || 0);

  // Promo code states
  const [promoCode, setPromoCode] = useState("");
  const [appliedPromo, setAppliedPromo] = useState(null);
  const [promoLoading, setPromoLoading] = useState(false);
  const [showAvailablePromos, setShowAvailablePromos] = useState(false);
  const [availablePromos, setAvailablePromos] = useState([]);

  const [cart, setCart] = useState(() => {
    const savedCart = sessionStorage.getItem('pharmacyCart');
    if (savedCart) {
      try {
        const parsedCart = JSON.parse(savedCart);
        if (parsedCart && parsedCart.length > 0) {
          console.log('✅ Cart restored from sessionStorage:', parsedCart);
          return parsedCart;
        }
      } catch (error) {
        console.error('Error parsing saved cart:', error);
      }
    }
    return initialCart || [];
  });

  const [formData, setFormData] = useState({
    full_name: "",
    phone: "",
    community_name: "",
    address_line1: "",
    address_line2: "",
    landmark: "",
    city: "",
    state: "",
    pincode: "",
    address_type: "home",
    delivery_time_option: "anytime",
    delivery_time: "",
  });

  const [originalFormData, setOriginalFormData] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [availableSlots, setAvailableSlots] = useState([]);
  const [errors, setErrors] = useState({});
  const [selectedDate, setSelectedDate] = useState("");
  const [isEditingAddress, setIsEditingAddress] = useState(false);

  // Subscription states
  const [subscriptionBenefits, setSubscriptionBenefits] = useState(null);
  const [subscriptionDiscount, setSubscriptionDiscount] = useState(0);
  const [loadingSubscription, setLoadingSubscription] = useState(false);

  // Fetch subscription benefits
  useEffect(() => {
    const fetchSubscriptionBenefits = async () => {
      const userId = sessionStorage.getItem("userId");
      const token = sessionStorage.getItem("token");
      
      if (!userId || !token) {
        console.log("No userId or token found");
        return;
      }

      const apiBaseUrl = process.env.REACT_APP_PRICING_API;
      if (!apiBaseUrl) {
        console.error("REACT_APP_PRICING_API is not configured in .env file");
        return;
      }

      setLoadingSubscription(true);
      try {
        const url = `${apiBaseUrl}/check-benefits/${userId}`;
        console.log("Fetching subscription benefits from:", url);

        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        });

        const contentType = response.headers.get("content-type");
        if (!contentType || !contentType.includes("application/json")) {
          console.error("API returned non-JSON response:", contentType);
          return;
        }

        if (!response.ok) {
          const errorText = await response.text();
          console.error(`API error (${response.status}):`, errorText);
          return;
        }

        const data = await response.json();
        console.log("Subscription benefits response:", data);

        if (data.success && data.has_subscription) {
          setSubscriptionBenefits(data);
          console.log("Active subscription found:", data.subscription.name);
        } else {
          console.log("No active subscription found for user");
          setSubscriptionBenefits(null);
        }
      } catch (error) {
        console.error("Error fetching subscription benefits:", error);
      } finally {
        setLoadingSubscription(false);
      }
    };

    fetchSubscriptionBenefits();
  }, []);

  // Calculate subscription discount
  useEffect(() => {
    if (subscriptionBenefits && subscriptionBenefits.has_subscription) {
      const medicineDiscountPercent = subscriptionBenefits.benefits.medicine_discount || 0;
      const discountAmount = (cartTotal * medicineDiscountPercent) / 100;
      setSubscriptionDiscount(discountAmount);
      console.log(`Subscription discount calculated: ${medicineDiscountPercent}% = ₹${discountAmount.toFixed(2)}`);
    } else {
      setSubscriptionDiscount(0);
    }
  }, [cartTotal, subscriptionBenefits]);

  const applySubscriptionToOrder = async () => {
    if (!subscriptionBenefits || !subscriptionBenefits.has_subscription) {
      console.log("No active subscription to apply");
      return null;
    }

    const userId = sessionStorage.getItem("userId");
    const token = sessionStorage.getItem("token");
    
    const apiBaseUrl = process.env.REACT_APP_PRICING_API;
    if (!apiBaseUrl) {
      console.error("REACT_APP_PRICING_API not configured");
      return null;
    }

    try {
      const url = `${apiBaseUrl}/apply-subscription`;
      console.log("Applying subscription discount to order:", url);

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          user_id: userId,
          service_type: "medicine",
          base_price: cartTotal
        })
      });

      const contentType = response.headers.get("content-type");
      if (!contentType || !contentType.includes("application/json")) {
        console.error("Apply subscription API returned non-JSON response");
        return null;
      }

      if (!response.ok) {
        const errorText = await response.text();
        console.error(`Apply subscription error (${response.status}):`, errorText);
        return null;
      }

      const data = await response.json();
      console.log("Subscription applied successfully:", data);
      return data;
    } catch (error) {
      console.error("Error applying subscription:", error);
      return null;
    }
  };

  useEffect(() => {
    setCart(prev =>
      prev.map((item, index) => ({
        ...item,
        id: item.id ? `${item.id}_${index}_${Date.now()}` : `${index}_${Date.now()}`
      }))
    );
  }, []);

  // Calculate cart total
  useEffect(() => {
    const newTotal = cart.reduce((sum, item) => sum + (item.price * item.quantity), 0);
    setCartTotal(newTotal);
  }, [cart]);

  // Fetch available promos
  useEffect(() => {
    fetchAvailablePromos();
  }, []);

  const fetchAvailablePromos = async () => {
    try {
      const userId = sessionStorage.getItem("userId");
      const token = sessionStorage.getItem("token");
      
      const response = await fetch(
        `${process.env.REACT_APP_APPLY_PROMOTION_API}/available?service_type=medicine&user_id=${userId}`,
        {
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );
      
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          setAvailablePromos(data.promotions || []);
        }
      }
    } catch (error) {
      console.error("Error fetching promos:", error);
    }
  };

  useEffect(() => {
    if (appliedPromo) {
      validateAppliedPromo();
    }
  }, [cartTotal]);

  const justAppliedPromo = React.useRef(false);

  const applyPromoCode = async (code) => {
    setPromoLoading(true);
    try {
      const userId = sessionStorage.getItem("userId");
      const token = sessionStorage.getItem("token");
      const response = await fetch(
        `${process.env.REACT_APP_APPLY_PROMOTION_API}/apply`,
        {
          method: "POST",
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            promo_code: code.toUpperCase(),
            service_type: "medicine",
            order_price: cartTotal,
            user_id: userId,
          }),
        });

      const data = await response.json();

      if (data.success) {
        justAppliedPromo.current = true;
        
        setAppliedPromo({
          code: data.promo_code,
          discount: data.discount_amount,
          title: data.title,
        });
        setPromoCode("");
        setShowAvailablePromos(false);
        setDialogMessage(data.message || "Promo code applied successfully!");
        setDialogOpen(true);
      } else {
        setDialogMessage(data.error || "Invalid promo code");
        setDialogOpen(true);
      }
    } catch (error) {
      console.error("Error applying promo:", error);
      setDialogMessage("Failed to apply promo code. Please try again.");
      setDialogOpen(true);
    } finally {
      setPromoLoading(false);
    }
  };

  const validateAppliedPromo = async () => {
    if (!appliedPromo) return;
    
    if (justAppliedPromo.current) {
      justAppliedPromo.current = false;
      return;
    }

    try {
      const userId = sessionStorage.getItem("userId");
      const token = sessionStorage.getItem("token");
      
      const response = await fetch(
        `${process.env.REACT_APP_APPLY_PROMOTION_API}/apply`,
        {
          method: "POST",
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            promo_code: appliedPromo.code,
            service_type: "medicine",
            order_price: cartTotal,
            user_id: userId,
          }),
        }
      );

      const data = await response.json();

      if (!data.success) {
        setAppliedPromo(null);
        setDialogMessage(`Promo code "${appliedPromo.code}" has been removed. ${data.error || "Your cart no longer meets the requirements."}`);
        setDialogOpen(true);
      } else if (data.discount_amount !== appliedPromo.discount) {
        setAppliedPromo({
          code: data.promo_code,
          discount: data.discount_amount,
          title: data.title,
        });
      }
    } catch (error) {
      console.error("Error validating promo:", error);
      setAppliedPromo(null);
    }
  };

  const removePromoCode = () => {
    setAppliedPromo(null);
    setDialogMessage("Promo code removed");
    setDialogOpen(true);
  };

  const updateQuantity = (itemId, change) => {
    setCart(prevCart => {
      const updatedCart = prevCart
        .map(item => {
          if (item.id === itemId) {
            const newQuantity = item.quantity + change;
            return { ...item, quantity: newQuantity };
          }
          return item;
        })
        .filter(item => item.quantity > 0);
  
      sessionStorage.setItem("pharmacyCart", JSON.stringify(updatedCart));
      return updatedCart;
    });

    if (appliedPromo) {
      setAppliedPromo(null);
    }
  };
  
  const removeItem = (itemId) => {
    setCart(prevCart => {
      const updatedCart = prevCart.filter(item => item.id !== itemId);
      sessionStorage.setItem("pharmacyCart", JSON.stringify(updatedCart));
      return updatedCart;
    });

    if (appliedPromo) {
      setAppliedPromo(null);
    }
  };
  
  const handleDateChange = (dateString) => {
    setSelectedDate(dateString);
    setSelectedSlot("");
    handleInputChange("delivery_time", "");

    const selected = new Date(dateString);
    const now = new Date();

    const isToday =
      selected.getDate() === now.getDate() &&
      selected.getMonth() === now.getMonth() &&
      selected.getFullYear() === now.getFullYear();

    let slots;
    if (isToday) {
      const currentHour = now.getHours();
      slots = TIME_SLOTS.map((slot) => ({
        ...slot,
        disabled: currentHour >= slot.end
      }));
    } else {
      slots = TIME_SLOTS.map((slot) => ({ ...slot, disabled: false }));
    }

    setAvailableSlots(slots);
  };

  useEffect(() => {
    const loadUserData = async () => {
      const userId = sessionStorage.getItem("userId");
      const token = sessionStorage.getItem("token");
      
      if (!userId || !token) {
        setUser(null);
        setLoading(false);
        return;
      }
  
      try {
        const userData = await fetchUserFromRedis(userId, token);
        console.log("📦 Received userData:", userData);
        
        if (userData) {
          setUser(userData);
          
          // ✅ CHANGE 1: Check if patient is new member and use their details
          if (patientDetails && patientDetails.patientType === "family" || patientDetails.patientType === "new") {
            console.log("🆕 New member detected, using patient details");
            setFormData({
              full_name: patientDetails.name || "",
              phone: patientDetails.phone || "",
              community_name: userData.address?.community_name || "",
              address_line1: userData.address?.address_line1 || "",
              address_line2: userData.address?.address_line2 || "",
              landmark: userData.address?.landmark || "",
              city: userData.address?.city || "",
              state: userData.address?.state || "",
              pincode: userData.address?.pincode || "",
              address_type: userData.address?.address_type || "home",
              delivery_time_option: "anytime",
              delivery_time: "",
            });
          } else if (userData.address && userData.address.full_name) {
            console.log("✅ Loading updated address from profile:", userData.address);
            setFormData({
              full_name: userData.address.full_name || userData.name || "",
              phone: userData.address.phone || userData.phone || "",
              community_name: userData.address.community_name || "",
              address_line1: userData.address.address_line1 || "",
              address_line2: userData.address.address_line2 || "",
              landmark: userData.address.landmark || "",
              city: userData.address.city || "",
              state: userData.address.state || "",
              pincode: userData.address.pincode || "",
              address_type: userData.address.address_type || "home",
              delivery_time_option: "anytime",
              delivery_time: "",
            });
          } else {
            setFormData(prev => ({
              ...prev,
              full_name: userData.name || "",
              phone: userData.phone || "",
            }));
          }
        }
      } catch (err) {
        console.error("Error fetching user from Redis:", err);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };
  
    loadUserData();
  }, [patientDetails]); // ✅ CHANGE 2: Added patientDetails as dependency

  const handleInputChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
    if (errors[field]) {
      setErrors({ ...errors, [field]: "" });
    }
  };

  const handleEditAddress = () => {
    setOriginalFormData({ ...formData });
    setIsEditingAddress(true);
  };

  const handleCancelEdit = () => {
    if (originalFormData) {
      setFormData(originalFormData);
    }
    setErrors({});
    setSelectedDate("");
    setSelectedSlot("");
    setIsEditingAddress(false);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.full_name.trim()) newErrors.full_name = "Full name is required";
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^(\+91)?\d{10}$/.test(formData.phone)) {
      newErrors.phone = 'Please enter a valid 10-digit phone number';
    }
  
    if (!formData.community_name.trim()) newErrors.community_name = "Community/Society name is required";
    if (!formData.address_line1.trim()) newErrors.address_line1 = "Block/Building is required";

    if (formData.delivery_time_option === "specific") {
      if (!selectedDate) newErrors.selectedDate = "Please select a delivery date";
      if (!formData.delivery_time) newErrors.delivery_time = "Please select a delivery time slot";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleProceed = async () => {
    if (cart.length === 0) {
      setDialogMessage("Your cart is empty. Please add items to proceed.");
      setDialogOpen(true);
      return;
    }

    if (!validateForm()) {
      setDialogMessage("Please fill all required fields correctly");
      setDialogOpen(true);
      return;
    }

    try {
      sessionStorage.setItem('pharmacyCart', JSON.stringify(cart));
      sessionStorage.setItem('pharmacyPatientDetails', JSON.stringify(patientDetails));
      sessionStorage.setItem('pharmacyDeliveryAddress', JSON.stringify(formData));
      if (prescriptionFile) {
        sessionStorage.setItem('pharmacyPrescription', prescriptionFile);
      }
      console.log('✅ Cart and details saved to sessionStorage before navigation');

      const subscriptionResponse = await applySubscriptionToOrder();

      const deliveryAddress = {
        ...formData,
        delivery_time_option: formData.delivery_time_option,
        delivery_time: formData.delivery_time_option === "anytime" ? "Anytime" : formData.delivery_time,
        delivery_date: selectedDate
      };

      const subscriptionData = subscriptionResponse || {
        applied: subscriptionBenefits?.has_subscription || false,
        discount_amount: subscriptionDiscount,
        subscription_name: subscriptionBenefits?.subscription?.name || null,
        subscription_id: subscriptionBenefits?.subscription?.subscription_id || null,
        discount_percent: subscriptionBenefits?.benefits?.medicine_discount || 0
      };

      console.log("Proceeding to payment with subscription data:", subscriptionData);

      navigate("/MedicinePayment", {
        state: {
          cart,
          orderType,
          patientDetails,
          totalAmount: finalAmount,
          prescriptionFile,
          deliveryAddress,
          userEmail: user?.email,
          userPhone: formData.phone,
          appliedPromo,
          subscriptionDiscount: subscriptionData.discount_amount,
          promoDiscount: appliedPromo ? appliedPromo.discount : 0, 
          promoCode: appliedPromo ? appliedPromo.code : "",
          subscriptionBenefits: subscriptionBenefits,
        }
      });
    } catch (error) {
      console.error("Error in handleProceed:", error);
      setDialogMessage("An error occurred. Please try again.");
      setDialogOpen(true);
    }
  };

  const deliveryCharge = Number(process.env.REACT_APP_DELIVERY_CHARGE) || 0;
  const discountAmount = appliedPromo ? appliedPromo.discount : 0;
  const finalAmount = cartTotal + deliveryCharge - subscriptionDiscount - discountAmount;

  const styles = {
    container: { flex: 1, backgroundColor: "#F9FAFB", minHeight: "100vh", paddingBottom: "100px" },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "16px",
      backgroundColor: "#fff",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      position: "sticky",
      top: 0,
      zIndex: 1000,
    },
    backButton: { padding: "8px", border: "none", background: "none", cursor: "pointer" },
    headerTitle: { fontSize: "20px", fontWeight: "700", color: "#111827", margin: 0 },
    scrollContent: { padding: "16px", maxWidth: "900px", margin: "0 auto", width: "90%" },
    card: {
      backgroundColor: "#fff",
      borderRadius: "16px",
      padding: "20px",
      marginBottom: "16px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    },
    cardTitle: { fontSize: "18px", fontWeight: "700", color: "#111827", marginBottom: "16px", marginTop: 0 },
    cartItem: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "12px",
      backgroundColor: "#F9FAFB",
      borderRadius: "12px",
      marginBottom: "12px",
    },
    itemDetails: { flex: 1 },
    itemName: { fontSize: "15px", fontWeight: "600", color: "#111827", marginBottom: "4px" },
    itemPrice: { fontSize: "14px", color: "#6B7280" },
    quantityControl: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
    },
    qtyButton: {
      width: "32px",
      height: "32px",
      borderRadius: "8px",
      border: "1px solid #D1D5DB",
      backgroundColor: "#fff",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "all 0.2s",
    },
    qtyText: { fontSize: "16px", fontWeight: "600", minWidth: "24px", textAlign: "center" },
    deleteButton: {
      padding: "8px",
      border: "none",
      background: "none",
      cursor: "pointer",
      color: "#EF4444",
    },
    addressSummary: {
      padding: "16px",
      backgroundColor: "#F9FAFB",
      borderRadius: "12px",
      marginBottom: "12px",
    },
    editButton: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      padding: "10px 16px",
      backgroundColor: "#006D77",
      color: "#fff",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      fontSize: "14px",
      fontWeight: "600",
      marginTop: "12px",
    },
    closeButton: {
      padding: "8px",
      border: "none",
      background: "none",
      cursor: "pointer",
      color: "#6B7280",
      display: "flex",
      alignItems: "center",
      gap: "4px",
      fontSize: "14px",
      fontWeight: "600",
    },
    summaryRow: { display: "flex", justifyContent: "space-between", marginBottom: "12px" },
    summaryLabel: { fontSize: "14px", color: "#6B7280" },
    summaryValue: { fontSize: "14px", fontWeight: "600", color: "#111827" },
    divider: { height: "1px", backgroundColor: "#E5E7EB", margin: "12px 0" },
    promoInput: { display: "flex", gap: "8px", marginTop: "12px" },
    input: {
      flex: 1,
      border: "1px solid #D1D5DB",
      borderRadius: "8px",
      padding: "10px 12px",
      fontSize: "14px",
      fontFamily: "inherit",
    },
    button: {
      padding: "10px 20px",
      borderRadius: "8px",
      border: "none",
      cursor: "pointer",
      fontSize: "14px",
      fontWeight: "600",
      transition: "all 0.2s",
    },
    primaryButton: { backgroundColor: "#006D77", color: "#fff" },
    secondaryButton: { backgroundColor: "#fff", color: "#006D77", border: "1px solid #006D77" },
    dangerButton: { backgroundColor: "#EF4444", color: "#fff" },
    promoTag: {
      display: "inline-flex",
      alignItems: "center",
      gap: "8px",
      backgroundColor: "#D1FAE5",
      color: "#065F46",
      padding: "8px 12px",
      borderRadius: "8px",
      fontSize: "14px",
      fontWeight: "600",
      marginTop: "8px",
    },
    promoCard: {
      border: "1px solid #E5E7EB",
      borderRadius: "12px",
      padding: "16px",
      marginBottom: "12px",
      cursor: "pointer",
      transition: "all 0.2s",
    },
    inputGroup: { marginBottom: "20px" },
    label: { fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "8px", display: "block" },
    required: { color: "#EF4444" },
    formInput: {
      width: "100%",
      border: "1px solid #D1D5DB",
      borderRadius: "8px",
      padding: "12px 16px",
      fontSize: "16px",
      color: "#111827",
      backgroundColor: "#fff",
      boxSizing: "border-box",
      fontFamily: "inherit",
    },
    inputError: { borderColor: "#EF4444" },
    errorText: { fontSize: "12px", color: "#EF4444", marginTop: "4px" },
    row: { display: "flex", gap: "16px" },
    addressTypeButton: {
      flex: 1,
      padding: "12px",
      borderRadius: "8px",
      border: "1px solid #D1D5DB",
      textAlign: "center",
      cursor: "pointer",
      backgroundColor: "#fff",
      transition: "all 0.2s",
    },
    addressTypeButtonActive: { backgroundColor: "#006D77", borderColor: "#006D77" },
    addressTypeText: { fontSize: "14px", fontWeight: "600", color: "#6B7280" },
    addressTypeTextActive: { color: "#fff" },
    deliverySummary: {
      marginTop: "16px",
      padding: "16px",
      backgroundColor: "#F0FDFA",
      borderRadius: "12px",
      border: "1px solid #CCFBF1",
      display: "flex",
      alignItems: "flex-start",
      gap: "12px",
    },
    deliverySummaryContent: {
      flex: 1,
    },
    deliverySummaryLabel: {
      fontSize: "12px",
      color: "#6B7280",
      marginBottom: "4px",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },
    deliverySummaryValue: {
      fontSize: "16px",
      fontWeight: "600",
      color: "#111827",
      lineHeight: "1.4",
    },
    buttonContainer: {
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: "#fff",
      padding: "16px",
      boxShadow: "0 -2px 8px rgba(0,0,0,0.1)",
      zIndex: 1000,
    },
    proceedButton: {
      backgroundColor: "#006D77",
      padding: "16px",
      borderRadius: "12px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      border: "none",
      cursor: "pointer",
      maxWidth: "900px",
      margin: "0 auto",
      width: "100%",
    },
    proceedButtonText: { color: "#fff", fontSize: "16px", fontWeight: "700", marginRight: "8px" },
    proceedButtonAmount: { color: "#fff", fontSize: "18px", fontWeight: "700" },
  };

  if (loading) {
    return (
      <div style={styles.container}>
        <div style={styles.header}>
          <button onClick={() => navigate(-1)} style={styles.backButton}>
            <ChevronLeft size={24} />
          </button>
          <h1 style={styles.headerTitle}>Delivery Address</h1>
          <div style={{ width: "40px" }} />
        </div>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "200px" }}>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button onClick={() => navigate(-1)} style={styles.backButton}>
          <ChevronLeft size={24} />
        </button>
        <h1 style={styles.headerTitle}>Delivery Address</h1>
        <div style={{ width: "40px" }} />
      </div>

      <div style={styles.scrollContent}>
        {/* Cart Items */}
        <div style={styles.card}>
          <h2 style={styles.cardTitle}>Cart Items ({cart.length})</h2>
          {cart.map((item) => (
            <div key={item.id} style={styles.cartItem}>
              <div style={styles.itemDetails}>
                <div style={styles.itemName}>{item.name}</div>
                <div style={styles.itemPrice}>₹{item.price.toFixed(2)} each</div>
              </div>
              <div style={styles.quantityControl}>
                <button
                  onClick={() => updateQuantity(item.id, -1)}
                  style={styles.qtyButton}
                  onMouseEnter={(e) => e.target.style.backgroundColor = "#F3F4F6"}
                  onMouseLeave={(e) => e.target.style.backgroundColor = "#fff"}
                >
                  <Minus size={16} />
                </button>
                <span style={styles.qtyText}>{item.quantity}</span>
                <button
                  onClick={() => updateQuantity(item.id, 1)}
                  style={styles.qtyButton}
                  onMouseEnter={(e) => e.target.style.backgroundColor = "#F3F4F6"}
                  onMouseLeave={(e) => e.target.style.backgroundColor = "#fff"}
                >
                  <Plus size={16} />
                </button>
                {cart.length > 1 && (
                  <button onClick={() => removeItem(item.id)} style={styles.deleteButton}>
                    <Trash2 size={18} />
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Order Summary */}
        <div style={styles.card}>
          <h2 style={styles.cardTitle}>Order Summary</h2>
          
          <div style={styles.summaryRow}>
            <span style={styles.summaryLabel}>Subtotal ({cart.length} items)</span>
            <span style={styles.summaryValue}>₹{cartTotal.toFixed(2)}</span>
          </div>
          
          <div style={styles.summaryRow}>
            <span style={styles.summaryLabel}>Delivery Charge</span>
            <span style={styles.summaryValue}>
              {deliveryCharge === 0 ? (
                <>
                  <span style={{ textDecoration: "line-through", color: "gray" }}>₹50</span> ₹0
                </>
              ) : (
                `₹${deliveryCharge}`
              )}
            </span>
          </div>

          {subscriptionBenefits && subscriptionBenefits.has_subscription && subscriptionDiscount > 0 && (
            <div style={styles.summaryRow}>
              <span style={{ ...styles.summaryLabel, color: "#8B5CF6" }}>
                Subscription Discount ({subscriptionBenefits.benefits.medicine_discount}%)
                <div style={{ fontSize: "11px", color: "#9CA3AF", marginTop: "2px" }}>
                  {subscriptionBenefits.subscription.name}
                </div>
              </span>
              <span style={{ ...styles.summaryValue, color: "#8B5CF6" }}>
                -₹{subscriptionDiscount.toFixed(2)}
              </span>
            </div>
          )}

          {appliedPromo && (
            <div style={styles.summaryRow}>
              <span style={{ ...styles.summaryLabel, color: "#10B981" }}>
                Discount ({appliedPromo.code})
              </span>
              <span style={{ ...styles.summaryValue, color: "#10B981" }}>
                -₹{appliedPromo.discount.toFixed(2)}
              </span>
            </div>
          )}

          <div style={styles.divider} />

          <div style={styles.summaryRow}>
            <span style={{ fontSize: "16px", fontWeight: "700", color: "#111827" }}>Total Amount</span>
            <span style={{ fontSize: "20px", fontWeight: "700", color: "#006D77" }}>
              ₹{finalAmount.toFixed(2)}
            </span>
          </div>

          {/* Promo Code Section */}
          {!appliedPromo ? (
            <>
              <div style={styles.promoInput}>
                <input
                  type="text"
                  placeholder="Enter promo code"
                  value={promoCode}
                  onChange={(e) => setPromoCode(e.target.value.toUpperCase())}
                  style={styles.input}
                />
                <button
                  onClick={() => applyPromoCode(promoCode)}
                  disabled={!promoCode || promoLoading}
                  style={{
                    ...styles.button,
                    ...styles.primaryButton,
                    opacity: !promoCode ? 0.5 : 1
                  }}
                >
                  {promoLoading ? "Applying..." : "Apply"}
                </button>
              </div>

              <button
                onClick={() => setShowAvailablePromos(!showAvailablePromos)}
                style={{
                  ...styles.button,
                  ...styles.secondaryButton,
                  width: "100%",
                  marginTop: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                <Tag size={16} />
                View Available Offers
                {showAvailablePromos ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
              </button>

              {subscriptionBenefits && subscriptionBenefits.has_subscription && (
                <div style={{
                  backgroundColor: "#F3E8FF",
                  padding: "12px",
                  borderRadius: "8px",
                  marginTop: "12px",
                  border: "1px solid #DDD6FE"
                }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px" }}>
                    <span style={{ fontSize: "14px", fontWeight: "600", color: "#7C3AED" }}>
                      🎉 Active Subscription
                    </span>
                  </div>
                  <div style={{ fontSize: "12px", color: "#6B7280" }}>
                    Saving {subscriptionBenefits.benefits.medicine_discount}% on medicine orders
                  </div>
                  <div style={{ fontSize: "11px", color: "#9CA3AF", marginTop: "4px" }}>
                    {subscriptionBenefits.subscription.days_remaining} days remaining
                  </div>
                </div>
              )}

              {showAvailablePromos && availablePromos.length > 0 && (
                <div style={{ marginTop: "12px" }}>
                  {availablePromos.map((promo, index) => (
                    <div
                      key={index}
                      style={styles.promoCard}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.borderColor = "#006D77";
                        e.currentTarget.style.backgroundColor = "#F0FDFA";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.borderColor = "#E5E7EB";
                        e.currentTarget.style.backgroundColor = "#fff";
                      }}
                      onClick={() => applyPromoCode(promo.promo_code)}
                    >
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start" }}>
                        <div>
                          <div style={{ fontSize: "16px", fontWeight: "700", color: "#111827", marginBottom: "4px" }}>
                            {promo.promo_code}
                          </div>
                          <div style={{ fontSize: "14px", color: "#6B7280", marginBottom: "8px" }}>
                            {promo.description}
                          </div>
                          <div style={{ fontSize: "12px", color: "#9CA3AF" }}>
                            Min order: ₹{promo.min_order_value}
                            {promo.max_discount > 0 && ` • Max discount: ₹${promo.max_discount}`}
                          </div>
                        </div>
                        <button
                          style={{
                            ...styles.button,
                            ...styles.primaryButton,
                            fontSize: "12px",
                            padding: "6px 12px"
                          }}
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>
          ) : (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div style={styles.promoTag}>
                <Tag size={16} />
                {appliedPromo.code} Applied
              </div>
              <button
                onClick={removePromoCode}
                style={{ ...styles.button, ...styles.dangerButton, fontSize: "12px", padding: "6px 12px" }}
              >
                Remove
              </button>
            </div>
          )}
        </div>

        {/* Address Form */}
        <div style={styles.card}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
            <h2 style={{ ...styles.cardTitle, marginBottom: 0 }}>Delivery Details</h2>
            {isEditingAddress && (
              <button onClick={handleCancelEdit} style={styles.closeButton}>
                <X size={20} />
                <span>Close</span>
              </button>
            )}
          </div>

          {!isEditingAddress ? (
            <>
              <div style={styles.addressSummary}>
                <div style={{ fontSize: "16px", fontWeight: "600", color: "#111827", marginBottom: "8px" }}>
                  <strong>Name:</strong> {formData.full_name}
                </div>
                <div style={{ fontSize: "14px", color: "#6B7280", marginBottom: "4px" }}>
                  <strong>Mobile:</strong> {formData.phone}
                </div>
                <div style={{ fontSize: "14px", color: "#6B7280", lineHeight: "1.6" }}>
                  <strong>Community Name:</strong> {formData.community_name} <br />
                  <strong>Block:</strong> {formData.address_line1} <br />
                  {formData.address_line2 && (
                    <>
                      <strong>Flat No:</strong> {formData.address_line2} <br />
                    </>
                  )}
                </div>
              </div>
              
              <button onClick={handleEditAddress} style={styles.editButton}>
                <Edit2 size={16} />
                Edit Address
              </button>
            </>
          ) : (
            <>
              <div style={styles.inputGroup}>
                <label style={styles.label}>
                  Full Name <span style={styles.required}>*</span>
                </label>
                <input
                  type="text"
                  readOnly={patientDetails?.patientType !== "new"}
                  style={{ 
                    ...styles.formInput, 
                    ...(errors.full_name ? styles.inputError : {}),
                    backgroundColor: patientDetails?.patientType !== "new" ? "#F5F5F5" : "#fff"
                  }}
                  placeholder="Enter your full name"
                  value={formData.full_name}
                  onChange={(e) => handleInputChange("full_name", e.target.value)}
                />
                {errors.full_name && <p style={styles.errorText}>{errors.full_name}</p>}
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}>
                  Phone Number <span style={styles.required}>*</span>
                </label>
                <input
                  type="tel"
                  readOnly={patientDetails?.patientType !== "new"}
                  style={{ 
                    ...styles.formInput, 
                    ...(errors.phone ? styles.inputError : {}),
                    backgroundColor: patientDetails?.patientType !== "new" ? "#F5F5F5" : "#fff"
                  }}
                  placeholder="Enter 10-digit phone number"
                  value={formData.phone}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                    handleInputChange("phone", value);
                  }}
                  maxLength={10}
                />
                {errors.phone && <p style={styles.errorText}>{errors.phone}</p>}
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}>
                  Community/Society Name <span style={styles.required}>*</span>
                </label>

                <input
                  type="text"
                  value={formData.community_name || ""}
                  readOnly
                  style={{
                    ...styles.formInput,
                    backgroundColor: "#f2f2f2",
                    cursor: "not-allowed",
                  }}
                />
              </div>

              {/* <div style={styles.inputGroup} >
                <label style={styles.label}>
                  Community/Society Name <span style={styles.required}>*</span>
                </label>
                <select
                  value={formData.community_name}
                  onChange={(e) =>
                    setFormData(prev => ({
                      ...prev,
                      community_name: e.target.value,
                    }))
                  }
                 style={styles.formInput}
                >
                  <option value="">Select Community</option>
                  {COMMUNITY_OPTIONS.map((community) => (
                    <option key={community} value={community}>
                      {community}
                    </option>
                  ))}
                </select>
              </div> */}

              <div style={styles.inputGroup}>
                <label style={styles.label}>
                  Block/Building <span style={styles.required}>*</span>
                </label>
                <select
                  style={{ ...styles.formInput, ...(errors.address_line1 ? styles.inputError : {}) }}
                  value={formData.address_line1}
                  onChange={(e) => handleInputChange("address_line1", e.target.value)}
                >
                  <option value="">Select Block</option>
                  {BLOCK_OPTIONS.map((block) => (
                    <option key={block} value={block}>
                      {block}
                    </option>
                  ))}
                </select>
                {errors.address_line1 && <p style={styles.errorText}>{errors.address_line1}</p>}
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}>Flat/House Number</label>
                <input
                  type="text"
                  style={styles.formInput}
                  placeholder="Flat or House Number (Optional)"
                  value={formData.address_line2}
                  onChange={(e) => handleInputChange("address_line2", e.target.value)}
                />
              </div>

              <button
                onClick={() => setIsEditingAddress(false)}
                style={{ ...styles.button, ...styles.secondaryButton, width: "100%", marginTop: "12px" }}
              >
                Save Address
              </button>
            </>
          )}
        </div>

        {/* Preferred Delivery Time - Separate Card */}
        <div style={styles.card}>
          <h2 style={styles.cardTitle}>Preferred Delivery Time</h2>

          <div style={styles.inputGroup}>
            <div style={{ display: "flex", gap: "12px" }}>
              <button
                type="button"
                style={{
                  ...styles.addressTypeButton,
                  ...(formData.delivery_time_option === "anytime" ? styles.addressTypeButtonActive : {}),
                }}
                onClick={() => {
                  handleInputChange("delivery_time_option", "anytime");
                  setSelectedDate("");
                  setSelectedSlot("");
                  setAvailableSlots([]);
                  setErrors((prev) => ({ ...prev, selectedDate: "", delivery_time: "" }));
                }}
              >
                <span
                  style={{
                    ...styles.addressTypeText,
                    ...(formData.delivery_time_option === "anytime" ? styles.addressTypeTextActive : {}),
                  }}
                >
                  Anytime
                </span>
              </button>
              
              <button
                type="button"
                style={{
                  ...styles.addressTypeButton,
                  ...(formData.delivery_time_option === "specific" ? styles.addressTypeButtonActive : {}),
                }}
                onClick={() => {
                  handleInputChange("delivery_time_option", "specific");
                  setSelectedDate("");
                  setSelectedSlot("");
                  setAvailableSlots([]);
                  setErrors((prev) => ({ ...prev, selectedDate: "", delivery_time: "" }));
                }}
              >
                <span
                  style={{
                    ...styles.addressTypeText,
                    ...(formData.delivery_time_option === "specific" ? styles.addressTypeTextActive : {}),
                  }}
                >
                  Specific Time
                </span>
              </button>
            </div>
          </div>

          {formData.delivery_time_option === "specific" && (
            <>
              <div style={styles.inputGroup}>
                <label style={styles.label}>
                  Select Date <span style={styles.required}>*</span>
                </label>
                <input
                  type="date"
                  value={selectedDate}
                  min={new Date().toISOString().split("T")[0]}
                  max={(() => {
                    const maxDate = new Date();
                    maxDate.setDate(maxDate.getDate() + 10);
                    return maxDate.toISOString().split("T")[0];
                  })()}
                  onChange={(e) => handleDateChange(e.target.value)}
                  onKeyDown={(e) => e.preventDefault()}   
                  onClick={(e) => e.currentTarget.showPicker()} 
                  style={{
                    ...styles.formInput,
                    cursor: "pointer",
                    ...(errors.selectedDate ? styles.inputError : {})
                  }}
                />
                {errors.selectedDate && <p style={styles.errorText}>{errors.selectedDate}</p>}
              </div>

              {selectedDate && availableSlots.length > 0 && (
                <div style={styles.inputGroup}>
                  <label style={styles.label}>
                    Available Time Slots <span style={styles.required}>*</span>
                  </label>
                  <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    {availableSlots.map((slot, index) => (
                      <button
                        key={index}
                        type="button"
                        disabled={slot.disabled}
                        onClick={() => {
                          const combined = `${selectedDate} | ${slot.label}`;
                          setSelectedSlot(slot.label);
                          handleInputChange("delivery_time", combined);
                          setErrors((prev) => ({ ...prev, delivery_time: "" }));
                        }}
                        style={{
                          padding: "12px",
                          borderRadius: "12px",
                          border: selectedSlot === slot.label ? "2px solid #006D77" : "1px solid #ccc",
                          background: selectedSlot === slot.label ? "#006D77" : slot.disabled ? "#eee" : "#fff",
                          color: selectedSlot === slot.label ? "#fff" : slot.disabled ? "#999" : "#333",
                          cursor: slot.disabled ? "not-allowed" : "pointer",
                          fontWeight: 600,
                          transition: "all 0.2s",
                        }}
                        onMouseEnter={(e) => {
                          if (!slot.disabled && selectedSlot !== slot.label) {
                            e.target.style.backgroundColor = "#f0f9ff";
                            e.target.style.borderColor = "#006D77";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!slot.disabled && selectedSlot !== slot.label) {
                            e.target.style.backgroundColor = "#fff";
                            e.target.style.borderColor = "#ccc";
                          }
                        }}
                      >
                        ⏱ {slot.label} {slot.disabled ? "(Unavailable)" : ""}
                      </button>
                    ))}
                  </div>
                  {errors.delivery_time && <p style={styles.errorText}>{errors.delivery_time}</p>}
                </div>
              )}
            </>
          )}

          <div style={styles.deliverySummary}>
            <Clock size={20} color="#006D77" />
            <div style={styles.deliverySummaryContent}>
              <div style={styles.deliverySummaryLabel}>Selected Time:</div>
              <div style={styles.deliverySummaryValue}>
                {formData.delivery_time_option === "anytime" 
                  ? "Anytime (We will deliver at the earliest)" 
                  : formData.delivery_time || "Not selected"}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={styles.buttonContainer}>
        <button
          style={styles.proceedButton}
          onClick={handleProceed}
          onMouseEnter={(e) => (e.target.style.backgroundColor = "#005761")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "#006D77")}
        >
          <span style={styles.proceedButtonText}>Proceed to Payment</span>
          <span style={styles.proceedButtonAmount}>₹{finalAmount.toFixed(2)}</span>
        </button>
      </div>

      <CustomDialog
        open={dialogOpen}
        message={dialogMessage}
        onClose={() => setDialogOpen(false)}
      />
    </div>
  );
};

export default MedicineDeliveryAddressScreen;